import { MLProductCodeUtil } from 'ml-portals-util-js'
import _ from 'lodash';

function Rewrite(data) {
    if (data) {
        _.extend(this, data);
    }
}

Rewrite.prototype.isHomeOwners = function () {
    return MLProductCodeUtil.isHomeOwners(this.policy.product.publicID);
};

Rewrite.prototype.isPersonalAuto = function () {
    return MLProductCodeUtil.isPersonalAuto(this.policy.product.publicID);
};

Rewrite.prototype.isPersonalUmbrella = function () {
    return MLProductCodeUtil.isPersonalUmbrella(this.policy.product.publicID);
};

Rewrite.prototype.isLandlordCondo = function () {
    return this.isHomeOwners() &&
        MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(this.policy.latestPeriod.lobs_ML.homeowners.coveragePartType_ML);
};

Rewrite.prototype.isLandlordHome = function () {
    return this.isHomeOwners() &&
        MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(this.policy.latestPeriod.lobs_ML.homeowners.coveragePartType_ML);
};

Rewrite.prototype.isOther = function () {
    return this.reasonForRewrite === 'other';
};

Rewrite.prototype.isChangeOffering = function () {
    return this.reasonForRewrite === 'change_offering';
};

Rewrite.prototype.isEffectiveDateChange = function () {
    return this.reasonForRewrite === 'change_eff_date';
};

export default Rewrite;